
import { useTranslation } from 'react-i18next';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Globe } from "lucide-react";
import { cn } from "@/lib/utils";

export default function LanguageSwitcher({ className = '' }) {
  const { i18n } = useTranslation();

  const handleValueChange = (value) => {
    i18n.changeLanguage(value);
  };

  return (
    <div className={cn("flex items-center", className)}>
      <Select value={i18n.language} onValueChange={handleValueChange}>
        <SelectTrigger 
          className="h-8 w-[130px] border-none bg-transparent font-bold uppercase tracking-wide focus:ring-0 focus:ring-offset-0"
        >
          <div className="flex items-center gap-2 text-inherit">
            <Globe className="size-4 opacity-70" />
            <SelectValue placeholder="Language" />
          </div>
        </SelectTrigger>
        <SelectContent className="bg-white/90 backdrop-blur-md dark:bg-black/90 dark:text-white border-white/20">
          <SelectItem value="en" className="font-bold uppercase tracking-wide">English</SelectItem>
          <SelectItem value="de" className="font-bold uppercase tracking-wide">Deutsch</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
